import { render, staticRenderFns } from "./PrenotazioniCupEdit.vue?vue&type=template&id=ce4dd568"
import script from "./PrenotazioniCupEdit.vue?vue&type=script&lang=js"
export * from "./PrenotazioniCupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports